import { useState } from 'react'
import { Link2 } from 'lucide-react'
import { toast } from 'sonner'
import { Button } from '@/components/ui/Button'
import api from '@/services/api'
import { useAuthStore } from '@/stores/authStore'

type Comercial = { id: string; name: string }

async function copyCloserLink(userId?: string) {
  const response = await api.get('/parceiros/cadastro-link', {
    params: userId ? { userId } : undefined,
  })
  const url = String(response.data?.data?.url ?? '')
  const name = String(response.data?.data?.closerName ?? 'closer')
  if (!url) throw new Error('sem link')
  try {
    await navigator.clipboard.writeText(url)
    toast.success(`Link de ${name} copiado`)
  } catch {
    toast.success(`Link de ${name}`, { description: url, duration: 12000 })
  }
}

/** Admin escolhe o closer. O closer copia só o próprio link. */
export function PartnerCadastroLinkButton() {
  const role = useAuthStore((state) => state.user?.role)?.toLowerCase()
  const [open, setOpen] = useState(false)
  const [comerciais, setComerciais] = useState<Comercial[]>([])
  const [loading, setLoading] = useState(false)

  if (role !== 'closer' && role !== 'admin' && role !== 'manager') return null

  async function copyOwn() {
    setLoading(true)
    try {
      await copyCloserLink()
    } catch {
      toast.error('Não foi possível gerar o seu link')
    } finally {
      setLoading(false)
    }
  }

  async function openPicker() {
    if (role === 'closer') {
      await copyOwn()
      return
    }
    setOpen((current) => !current)
    if (comerciais.length > 0) return
    try {
      const response = await api.get('/parceiros/comerciais')
      setComerciais(response.data?.data ?? [])
    } catch {
      toast.error('Não foi possível listar os closers')
    }
  }

  return (
    <div className='relative shrink-0'>
      <Button
        type='button'
        variant='secondary'
        size='sm'
        className='shrink-0'
        icon={<Link2 size={13} />}
        disabled={loading}
        onClick={() => void openPicker()}
      >
        Link de cadastro
      </Button>
      {open && role !== 'closer' && (
        <div className='absolute right-0 z-20 mt-2 w-64 rounded-xl border border-[var(--border)] bg-[var(--bg-card)] p-2 shadow-xl'>
          <p className='px-2 py-1 text-[11px] text-[var(--text-muted)]'>Escolha o closer. O cadastro fica no nome dele.</p>
          <ul className='max-h-56 overflow-y-auto'>
            {comerciais.map((closer) => (
              <li key={closer.id}>
                <button
                  type='button'
                  className='w-full rounded-md px-2 py-1.5 text-left text-sm text-[var(--text-primary)] hover:bg-white/5'
                  onClick={() => {
                    void copyCloserLink(closer.id)
                      .catch(() => toast.error('Não foi possível gerar o link'))
                      .finally(() => setOpen(false))
                  }}
                >
                  {closer.name}
                </button>
              </li>
            ))}
            {comerciais.length === 0 && (
              <li className='px-2 py-2 text-xs text-[var(--text-muted)]'>Nenhum closer ativo.</li>
            )}
          </ul>
        </div>
      )}
    </div>
  )
}
